import { createFileRoute } from '@tanstack/react-router'
import { Site } from 'pages/site/Site'
import { z } from 'zod'

const parseParams = z.object({
  orgID: z.string(),
  siteID: z.string(),
})

const searchParams = z.object({
  mode: z.enum(['edit']),
})

export const Route = createFileRoute('/organization_/$orgID/site/$siteID')({
  component: Site,
  params: {
    parse: parseParams.parse,
  },
  validateSearch: searchParams,
  staticData: {
    title: 'Site Details',
    layout: {
      enableScrolling: true,
    },
  },
})
